import React from "react";
import Header from "./Header";
import UsersTable from "./UserTable";

function AdminDashboard() {
  return (
    <Header
      pageTitle="Admin Dashboard"
      pageSubtitle="Monitor users and manage account status"
    >
      <div>
        <UsersTable />
      </div>
    </Header>
  );
}

export default AdminDashboard;
